import { TranslateService } from '@ngx-translate/core';
import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PickingAssignmentServiceService } from '../../services/picking-assignment-service.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { getDataScopeByPermission } from 'src/app/core/utils/common-functions';
import { deepCopy, getDefaultDT, getForwarderByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { CarSequenceService } from '../../services/car-sequence.service';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';


@Component({
  selector: 'laas-picking-assignment',
  templateUrl: './picking-assignment.component.html',
  styleUrls: ['./picking-assignment.component.scss']
})
export class PickingAssignmentComponent extends SessionBaseComponent implements OnInit {


  readonly preferenceKey: string = UserPreferenceConstants.PickingAssignment;
  readonly preferenceKey2 : string = UserPreferenceConstants.PickingAssignmentDetail;
  readonly permissionCode =  PermissionConstants.ViewAssignPickTask;
  readonly BtnAssignPickTaskAssign = PermissionConstants.BtnAssignPickTaskAssign;

  currentLang: string = this.laasSetting.language;
  @ViewChild('AssignDate') assignDate!: CalendarComponent;
  @ViewChild('IssuanceDate') issuanceDate!: CalendarComponent;
  isSearchFormOpen: boolean;
  isShowAssignModal: boolean;
  isLoading: boolean;
  mainRows: any[];
  searchParams: any;
  searchForm: FormGroup;
  selectedFilterScope: number;
  assignShipping: string | null;
  isShowPickCount: boolean;
  pickedCount: string;
  toBePickedCount: string;
  forwarderOptions: any[];
  carSeqOptions: any[];
  dropBepicked: string;
  dropUnpicked: string;

  columns: any[];
  detailColumns: any[];
  carTrips: any[];

  selectedRows : any[];

  isAssignEnabled: boolean;

  constructor(
    injector: Injector,
    private fb: FormBuilder,
    private dropdownOptionsService: DropdownOptionsService,
    private carSeqService: CarSequenceService,
    private pickingAssignmentServiceService: PickingAssignmentServiceService,
    private translate: TranslateService) {
      super(injector);
      this.isSearchFormOpen = true;
      this.isShowAssignModal = false;
      this.pickedCount = "";
      this.toBePickedCount = "";
      this.dropBepicked = "";
      this.dropUnpicked = "";
      this.isLoading = false;
      this.isShowPickCount = false;
      this.selectedFilterScope = 1;
      this.forwarderOptions = [];
      this.carSeqOptions = [];
      this.mainRows = [];
      this.carTrips = [];
      this.selectedRows = [];
      this.isAssignEnabled = false;

      var now = new Date(),
        month = now.getMonth(),
        day = now.getDate(),
        year = now.getFullYear();

      var defaultDate = new Date(new Date(year, month, day, 0, 0, 0).toISOString());

      this.searchParams = {
        consigneeKeys: [],
        bookingNos:  [],
        doNos:  [],
        bookingForwarders: [],
        assignDate : null,
        carTrip:null,
        carSeq:null,
        createDt: defaultDate,
      };
      this.searchForm = this.fb.group({
        consigneeKeys: [],
        bookingNos:  [],
        doNos:  [],
        bookingForwarders: [],
        assignDate : null,
        carTrip:null,
        carSeq:null,
        createDt: defaultDate,
      });
      this.assignShipping = null;

      this.columns = this.tableTranslation();
      this.detailColumns = this.detailTableTranslation();


      this.translate.onLangChange.subscribe((e: Event) => {
        this.tableTranslation();
        this.detailTableTranslation();
      });
      this.tableTranslation();
      this.detailTableTranslation();
  }




  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.dropdownOptionsService.getForwarderOptions().subscribe({
      next: (options: any[]) => {
        this.forwarderOptions = options.filter((x: any) => {
          return ( this.userProfile.userType == UserType.SuperAdmin.toString() ||
          this.userProfile.userType == UserType.Shipping.toString() ||
           getForwarderByPermission(this.userProfile, this.permissionCode).includes(x.optionCode));
        }).map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    var canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    this.isAssignEnabled = this.permissionCodes.includes(this.BtnAssignPickTaskAssign);
    this.searchBtnClick("1");
  }

  getPickCount(event: any, createUser:string): void{

    this.loader.show();

    this.pickingAssignmentServiceService.getPickCount(createUser).subscribe({
      next: result => {
        this.pickedCount = result.pickedCount ?? "-";
        this.toBePickedCount = result.toBePickedCount ?? "-";
        this.dropBepicked = result.dropBepicked ?? "-";
        this.dropUnpicked = result.dropUnpicked ?? "-";;
      },
      complete: () => {
        this.loader.hide();
        this.isShowPickCount = true;
      }
    });
  }

  searchBtnClick(type : string): void {

    if(type != "1"){
      if( this.searchParams.consigneeKeys.length == 0 &&
        this.searchParams.bookingNos.length == 0 &&
        this.searchParams.doNos.length == 0 &&
        this.searchParams.bookingForwarders.length == 0 &&
        isNullOrEmpty(this.searchParams.carTrip) &&
        isNullOrEmpty(this.searchParams.assignDate) &&
        isNullOrEmpty(this.searchParams.carSeq) &&
        isNullOrEmpty(this.searchParams.createDt) ){
          this.translateService.get('AssignPicker.Alert.MustFill')
            .subscribe({
              next: result => {
                this.toastService.warn(result);
                return;
              }
            });
        return;
      }
    }

    this.isLoading = true;
    this.mainRows = [];

    this.searchParams.facility = this.laasSetting.facility;
    this.searchParams.dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);

    // assignDate改成字串
    const params = deepCopy(this.searchParams);
    if(!isNullOrEmpty(params.assignDate)){
      params.assignDate = this.formatDate(params.assignDate);
    }
    this.pickingAssignmentServiceService.getBooking(params).subscribe({
      next: result => {
        this.isSearchFormOpen = !this.isSearchFormOpen;
        this.mainRows = result;

      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  searchDetailClick(event: any): void{
    const rowData = event.rowData;
    const isClosed = event.expanded;
    if (isClosed) {
      return;
    }

    let carTrip = event.rowData.carTrip;
    let dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);

    let tempObj: any;
    tempObj = {carTrip : carTrip ,facility : this.laasSetting.facility ,  dataScopes : dataScopes };

    this.pickingAssignmentServiceService.getCarTripDetail(tempObj).subscribe({
      next: result => {

        event.rowData.doNos = result;

      },
      complete: () => {
        this.loader.hide();
      }
    })
  }


  assignBtnClick(event: any): void {
    this.assignShipping = null;
    this.isShowAssignModal = true;
  }


  getCheckedDos(): any[]{
    return (Object.values(this.mainRows).reduce((c: any, i: any) => c.concat(i.doNos), []) as any[]).filter((x: any) => {
      return x && x.checked;
    });
  }

  modalConfirmBtnClick(event: any): void {

    var doNos = this.getCheckedDos().map((x: any) => {
      return x.doNo;
    });

    console.log("doNos:",doNos);

    if(doNos.length == 0){
      this.toastService.warn('請勾選交貨單號');
      return;
    }

    this.pickingAssignmentServiceService.AssignShipping(
      doNos,
      this.userProfile.uuid,
      (this.assignShipping == null ? "" : this.assignShipping),
      this.laasSetting.facility
      ).subscribe({
      next: result => {
        console.log(result);
        this.searchBtnClick("1");
      },
      error: (err) => {
        console.log(err);
        this.toastService.error(`${err.error.errorCode} ${err.error.errorMsg}`);
      },
      complete: () => {
        this.isShowAssignModal = false;
      }
    });
  }

  modalCancelBtnClick(event: any): void {
    this.assignShipping = null;
    this.isShowAssignModal = false;
  }

  modalHide(event: any): void {
    this.assignShipping = null;
  }


  bookingNoChipsAdd(event: any): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    this.searchParams.bookingNos.splice(this.searchParams.bookingNos.indexOf(value));
    this.searchParams.bookingNos = this.searchParams.bookingNos.concat(parsedValues);
  }

  doNoChipsAdd(event: any): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    this.searchParams.doNos.splice(this.searchParams.doNos.indexOf(value));
    this.searchParams.doNos = this.searchParams.doNos.concat(parsedValues);
  }

  consigneeKeyChipsAdd(event: any): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    this.searchParams.consigneeKeys.splice(this.searchParams.consigneeKeys.indexOf(value));
    this.searchParams.consigneeKeys = this.searchParams.consigneeKeys.concat(parsedValues);
  }

  bookingAccordionTabOpen(): void {
    this.isSearchFormOpen = true;
  }

  formatDate(date : any) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('');
  }


  // translate table
  tableTranslation(): any[] {
    var fields: string[];
    var jsons: string[];
    var tmpcolumn: any[] = [];

    fields = ['forwarderCodeAndName','assignDate','carSeq','carTrip','carNoNote',
      'bookingNoCount','expectedCnt','dropCnt','bepicked1','bepicked2','assignUser','createUser'];
    jsons = ['AssignPicker.MainTable.Form.Forwarder','AssignPicker.MainTable.Form.AssignDate',
      'AssignPicker.MainTable.Form.DepartureTime','AssignPicker.MainTable.Form.CarTripNum',
      'AssignPicker.MainTable.Form.VehicleNumRemarks','AssignPicker.MainTable.Form.BookingQty','AssignPicker.MainTable.Form.TotalCartonCnt',
      'AssignPicker.MainTable.Form.DropShipCartonCnt','AssignPicker.MainTable.Form.LoadCarCartonCnt','AssignPicker.MainTable.Form.LeaveWare',
      'AssignPicker.MainTable.Form.NoPicker','AssignPicker.MainTable.Form.Issuer'];
    for (let i = 0; i < fields.length; i++) {
      this.translateService.get(jsons[i])
      .subscribe((translation : string) => {
        tmpcolumn[i]= ({ field: fields[i], header: translation, sort: true })
        console.log('run, ' ,tmpcolumn)
      });
    }
    return tmpcolumn;

  }


  detailTableTranslation(): any[] {
    var fields: string[];
    var jsons: string[];
    var tmpcolumn: any[] = [];

    fields = ['__check','bookingNo','doNo','floorExBkIds','consigneeKey','consigneeCompany','expectedCnt',
      'bepicked1','bepicked2','dropCnt1','dropCnt2','dropBepicked','status','createUser','assignType','createDt'];
    jsons = ['選取','AssignPicker.SubTable.BookingNum','AssignPicker.SubTable.DONum','下線棧板號',
      'AssignPicker.SubTable.CustomerCode','AssignPicker.SubTable.CustomerName','AssignPicker.SubTable.TotalCartonCnt',
      'AssignPicker.SubTable.LoadCarCartonCnt','AssignPicker.SubTable.LeaveWare','AssignPicker.SubTable.TotalDropCartonCnt',
      'AssignPicker.SubTable.DropShipLoadCount','AssignPicker.SubTable.DropShipLeaveCount','AssignPicker.SubTable.Status','揀貨人員','取單類型','AssignPicker.MainTable.Form.IssuanceDate'];

    for (let i = 0; i < fields.length; i++) {
      this.translateService.get(jsons[i])
      .subscribe((translation : string) => {
        tmpcolumn[i]= ({ field: fields[i], header: translation, sort: true })
      });
    }
    return tmpcolumn;

  }

  dateOnChange(date: any,type:string) {
    switch(type){
      case "AssignDate" :
        this.searchParams.assignDate = date.date;
        break;
      case "IssuanceDate" :
        this.searchParams.createDt = date.date;
        break;
    }
  }

}
